import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {ModuleWithProviders} from '@angular/core';
import {AppComponent} from './app.component';
import {AppModule} from './app.module';

export const routes: Routes = [
  {
    path: '',
    component: AppComponent,
    children: [
      { path: '', redirectTo: 'auth', pathMatch: 'full' },
      {
        path: 'app',
        loadChildren: () =>
          import('./components/layout/layout.module').then(
            (m) => m.LayoutModule,
          ),
      },
      {
        path: 'auth',
        loadChildren: () =>
          import('./components/authentication/authentication.module').then(
            (m) => m.AuthenticationModule,
          ),
      },
      { path: '**', redirectTo: 'auth' },
    ],
  },
];

export const routing: ModuleWithProviders<AppModule> = RouterModule.forRoot(routes, {
  useHash: true,
  preloadingStrategy: PreloadAllModules,
  onSameUrlNavigation: 'reload'
});
